export default "__VITE_ASSET__BpG3GTzw__"